import axios from "axios";
import api from "../../api";

const state = {
  isLoading: false,
  productivityLoading: false,
  TotalMonth: 27,
  loading: true,
  InternalRequest: [],
  tasks: [],
  totalTasks: "",
  requests: [],
  loading_request: true,
  chosenUser: -1, // ID of the user that the "super user" can select on the dropdown that is above the task cards
  chosenUserName: "", // Name of the user that the "super user" can select on the dropdown that is above the task cards
  chosenUserImage: "", // Image URL of the user that the "super user" can select on the dropdown that is above the task cards
  productivityByPersonRequest: null,
  productivityByDeparmentRequest: null,
  productivityTaskRequest: null,
  productivityAllTaskRequest: null,

  model: {
    TargetValue: 0,
    TotalRequest: 0,
    InternalRequest: [],
    IconCuality: "down",
    ColorCuality: "danger-text"
  },

  model2: {
    TargetValue2: 0,
    TotalRequest2: 0,
    InternalRequest2: [],
    IconCuality2: "down",
    ColorCuality2: "danger-text"
  }
};

const getters = {
  Total: (state) => {
    return state.requests.length;
  },
  TotalEstrellas: (state) => {
    if (state.requests.length <= 0) {
      return 0;
    }

    return state.requests
      .filter((item) => item.Assessment > 0)
      .map((item) => item.Assessment)
      .reduce((a, c) => a + c);
  },
  promedio: (state, getters) => {
    if (getters.TotalEstrellas <= 0 || getters.Total <= 0) {
      return 0;
    }
    return getters.TotalEstrellas / getters.Total;
  },
  calInternalServicePercent: (state, getters) => {
    return !getters.promedio
      ? "0%"
      : parseInt((getters.promedio / 5) * 100, 10).toString() + "%";
  },
  getTagType: (state, gettes) => {
    if (gettes.calInternalServicePercent.replace("%", "") <= 70) {
      return "danger";
    } else if (gettes.calInternalServicePercent.replace("%", "") >= 90) {
      return "success";
    } else if (
      gettes.calInternalServicePercent.replace("%", "") >= 71 &&
      gettes.calInternalServicePercent.replace("%", "") <= 89
    ) {
      return "warning";
    }
    return "info";
  }
};

const mutations = {
  SET_PRODUCTIVITYlIST(state, payload) {
    state.requests = payload;
    state.loading_request = false;
  },
  SET_PRODUCTIVITYlIST2(state, payload) {
    state.requests = payload;
    state.loading_request = false;
  },
  SET_PRODUCTIVITY(state, payload) {
    state.model = payload;
    state.chosenUserName = payload.EmployeeName;
    state.chosenUserImage = payload.EmployeeImageUrl;
  },
  SET_PRODUCTIVITY2(state, payload) {
    state.model2 = payload;
    state.chosenUserName = payload.EmployeeName;
    state.chosenUserImage = payload.EmployeeImageUrl;
  },
  LoadingOff(state, payload) {
    state.loading = payload;
  },
  SET_TASK(state, payload) {
    state.tasks = payload;
    state.totalTasks = payload.length;
  },
  SET_REQUEST(state, payload) {
    state.tasks = payload;
  },
  SET_CHOSEN_USER(state, payload) {
    state.chosenUser = payload;
  },
  SET_TOGGLE_LOADING(state) {
    state.isLoading = !state.isLoading;
  },
  SET_PRODUCTIVITY_LOADING(state, payload) {
    state.productivityLoading = payload;
  },
  CLEAR_TASKS(state) {
    state.tasks = [];
    state.totalTasks = "";
  },
  CLEAR_REQUEST(state) {
    state.requests = [];
  }
};

const actions = {
  async GetProductivityByPersonAsync(context, payload) {
    context.commit("SET_PRODUCTIVITY_LOADING", true);

    if (this.productivityByPersonRequest) {
      this.productivityByPersonRequest.cancel();
    }

    const request = axios.CancelToken.source();
    this.productivityByPersonRequest = { cancel: request.cancel };

    try {
      const { data } = await api.get("/api/productivity/productivityByPerson", {
        cancelToken: request.token,
        params: { ...payload },
        timeout: 1000 * 60 * 3
      });
      //console.log("productivity data: ",data)
      context.commit("SET_PRODUCTIVITY", data);
      context.commit("SET_PRODUCTIVITY_LOADING", false);
    } catch (error) {
      context.commit("SET_PRODUCTIVITY_LOADING", false);
    }
  },
  async GetProductivityByDeparmentAsync(context, payload) {
    context.commit("SET_PRODUCTIVITY_LOADING", true);

    if (this.productivityByDeparmentRequest) {
      this.productivityByDeparmentRequest.cancel();
    }

    const request = axios.CancelToken.source();
    this.productivityByDeparmentRequest = { cancel: request.cancel };

    try {
      const { data } = await api.get(
        "/api/productivity/productivityByDepartment",
        {
          cancelToken: request.token,
          params: { ...payload },
          timeout: 1000 * 60 * 3
        }
      );
      //console.log("productivity2 data: ",data)
      context.commit("SET_PRODUCTIVITY2", data);
      context.commit("SET_PRODUCTIVITY_LOADING", false);
    } catch (error) {
      context.commit("SET_PRODUCTIVITY_LOADING", false);
    }
  },
  async GetTaks(context, payload) {
    context.commit("SET_TOGGLE_LOADING");

    if (this.productivityTaskRequest) {
      this.productivityTaskRequest.cancel();
    }

    const request = axios.CancelToken.source();
    this.productivityTaskRequest = { cancel: request.cancel };

    try {
      const { data } = await api.get("/api/productivity/productivityTask", {
        cancelToken: request.token,
        params: { ...payload }
      });
      context.commit("SET_TASK", data);
      context.commit("SET_TOGGLE_LOADING");
    } catch (error) {
      context.commit("SET_TOGGLE_LOADING");
    }
  },
  async GetTaksAll(context, payload) {
    context.commit("SET_TOGGLE_LOADING");

    if (this.productivityAllTaskRequest) {
      this.productivityAllTaskRequest.cancel();
    }

    const request = axios.CancelToken.source();
    this.productivityAllTaskRequest = { cancel: request.cancel };

    try {
      const { data } = await api.get("/api/productivity/productivityAllTask", {
        cancelToken: request.token,
        params: { ...payload }
      });
      context.commit("SET_TASK", data);
      context.commit("SET_TOGGLE_LOADING");
    } catch (error) {
      context.commit("SET_TOGGLE_LOADING");
    }
  },
  async GetInteralRequest(context, payload) {
    context.commit("SET_TOGGLE_LOADING");
    const request = axios.CancelToken.source();
    try {
      const { data } = await api.get(
        "/api/productivity/productivityInteralRequest",
        {
          cancelToken: request.token,
          timeout: 3 * 60 * 1000,
          params: payload
        }
      );
      context.commit("SET_PRODUCTIVITYlIST", data);
      context.commit("SET_TOGGLE_LOADING");
    } catch (error) {
      context.commit("SET_PRODUCTIVITYlIST", []);
      context.commit("SET_TOGGLE_LOADING");
    }
  },
  async GetInternalRequestsDeparment(context, payload) {
    context.commit("SET_TOGGLE_LOADING");
    const request = axios.CancelToken.source();
    try {
      const { data } = await api.get(
        "/api/productivity/produInteralRequestDeparment",
        {
          cancelToken: request.token,
          timeout: 3 * 60 * 1000,
          params: payload
        }
      );
      context.commit("SET_PRODUCTIVITYlIST2", data);
      context.commit("SET_TOGGLE_LOADING");
    } catch (error) {
      context.commit("SET_PRODUCTIVITYlIST2", []);
      context.commit("SET_TOGGLE_LOADING");
    }
  },
  SetChosenUser(context, payload) {
    context.commit("SET_CHOSEN_USER", payload);
  },
  CleanTasks(context) {
    context.commit("CLEAR_TASKS");
  },
  CleanRequests(context) {
    context.commit("CLEAR_REQUEST");
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
